export const ReportModuleRidrection = {
    NOT_REDIRECTED:0,
    ACCOUNT: 1,
    BRAND: 2,
    PARTNER: 3,
    CREATIVE: 4,
    STRATEGY: 5,
    SITE: 6,
    CAMPAIGN_ANALYSIS_RICH_MEDIA: 7,
    CAMPAIGN_RICH_MEDIA: 8,
  };
  